import { useState } from 'react';
import { InvoiceClient, InvoiceDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useInvoiceApi = () => {
    const apiClient = new InvoiceClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: InvoiceDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createInvoice(data);
        } catch (err: any) {
            setError(err.message || 'Error creating Invoice');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: InvoiceDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateInvoice(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating Invoice');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getInvoiceById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching Invoice');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchInvoices(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching Invoices');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteInvoice(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting Invoice');
        } finally {
            setIsLoading(false);
        }
    };

    const getInvoiceSasUrl = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getInvoiceDownloadLink(id);
        } catch (err: any) {
            setError(err.message || 'Error getting invoice link');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, getInvoiceSasUrl, isLoading, error };
};